import { render, staticRenderFns } from "./OperacoesNaoImportadas.vue?vue&type=template&id=6b4b2666"
import script from "./OperacoesNaoImportadas.vue?vue&type=script&lang=js"
export * from "./OperacoesNaoImportadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports